import helpers from '@/utils/helpers.ts'
import { useDeepAdminUsersMeStore } from '@/stores/deepadmin/users/users-me'

export function useOrganizationBetaFeatures() {
  const { getOrganizationById } = useDeepAdminUsersMeStore()

  function isAbaNinjaBoxEnabled(orgId: string) {
    const org = getOrganizationById(orgId)
    return !helpers.isPersonalStructure(org)
  }

  return {
    isAbaNinjaBoxEnabled,
  }
}
